import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submitNewsletter } from '../../data/actions/index';
import Newsletter from '../components/Newsletter';

class NewsletterContainer extends Component {
    static propTypes = {
        submitted: PropTypes.bool,
        confirmation: PropTypes.bool,
        submitNewsletter: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.emailInput = null;

        this.setInputRef = element => {
            this.emailInput = element;
        };
    }

    handleOnSubmit= (e) => {
        e.preventDefault();
        this.props.submitNewsletter(this.emailInput.value);
    }

    render() {
        const { success, error, isFetching } = this.props;

        return (
            <Newsletter
                onSubmit={this.handleOnSubmit}
                inputRef={this.setInputRef}
                success={success}
                error={error}
                isFetching={isFetching}
            />
        );
    }
}

export default connect(
    state => ({
        error: state.error,
        success: state.success,
        isFetching: state.isFetching
    }),
    dispatch => bindActionCreators({ submitNewsletter }, dispatch)
)(NewsletterContainer);
